import { REPORT_NUMBER_TYPES } from 'Components/UI/EAReport/constants'
import moment from 'moment'

export interface ExportColumn {
  dataIndex: string
  title: string
  type?: string
  exportRender?: (value: unknown, record: Record<string, unknown>) => string | number
  exportable?: boolean
  summary?: boolean
  columns?: ExportColumn[]
}

const DATE_FORMATS = ['YYYY-MM-DDTHH:mm:ss.SSSZ', 'YYYY-MM-DDTHH:mm:ssZ', 'YYYY-MM-DD']

const formatValueCsv = (value: unknown, column: ExportColumn, record: Record<string, unknown>): string | number => {
  if (column.exportRender) return column.exportRender(value, record)

  if (value && typeof value === 'string' && moment(value, DATE_FORMATS, true).isValid())
    return moment(value).format('DD/MM/YYYY HH:mm:ss')

  if (REPORT_NUMBER_TYPES.includes(column.type as never))
    return (record[`${column.dataIndex}_csv`] as string) || (value as string | number)

  if (value === null || value === undefined) return ''

  return value as string | number
}

export default formatValueCsv
